/**
 * Created by marc on 29.12.16.
 */
export { WizardModule } from './wizard.module';
export * from './components';
export * from './directives';
export * from './util';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-archwizard/dist/components/index.js
// module id = 1005
// module chunks = 4